import { Button } from '@bambi/component-library/src/components/Button/Button';

import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { Modal } from 'src/common/primitives/Modal';
import { tripSlice } from 'src/features/trip/trip.slice';

import { TripStatusUpdatesEditor } from './TripStatusUpdatesEditor';

export default function TripStatusUpdatesModal() {
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(
    (state) => state.trip.tripStatusUpdatesModal.isOpen
  );

  const handleClose = () => {
    dispatch(tripSlice.actions.onCloseTripStatusUpdates());
  };

  return (
    <Modal
      open={isOpen}
      setOpen={(val) => {
        if (!val) {
          handleClose();
        }
      }}
      contentClassnames="max-w-3xl"
      title="Trip Status Updates"
    >
      <div className="flex flex-col gap-6">
        <TripStatusUpdatesEditor />
        <div className="flex justify-end gap-4 pt-4">
          <Button variant="primary" onClick={handleClose}>
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
}
